// 特殊用户ID列表 - 用于首页功能权限控制
export const SPECIAL_USER_IDS = [
  'cc43u5s0cbdfmpoeugn0',
  'c8bg3m39ano5ppmmn8ig',
  'c8bg8b39ano5ppmmn8m0',
  'cau08f1rrtbujhren63g',
  'cbu58hhdi25drlujq6qg',
  'cgbtbv40cbdfj9shqa80',
  'cgbtlii6j4uvam1uvjr0',
  'cgbravk0cbdfj9shqa80',
  'caugdrhrrtbujhrenm7g',
  'ckjlns4m115on7hskic0',
  'ck1a6duc1943slnilerg',
  'c29p60ui21psb4j3lcv0',
  'c2jmps6i21pqgmorbgtg',
  'c652hdj9ano2nl7vqdhg',
  'c2d465ei21pqgmor99og', // steven的生产账号
  'cec391pdi2556b9uhacg', // 用户-等我的猪回来
  'c39vfm39ano13hgh9o0g', // ELAS的王芬的账号
]
